import React from 'react';
import './Chapters.scss';
import Hyperlink from '../Hyperlink/Hyperlink';

function Chapter4() {
  const hyperlinkData = [{ href: 'https://www.youtube.com/watch?v=aTl8V8hO7ZQ', copy: 'video' }];
  return (
    <section className="chapter">
      <h3 className="chapter-title">The Promise of “Off-the-Shelf” Treatments</h3>
      <p className="chapter-paragraph">
        The development of allogeneic, or “off-the-shelf,” CAR T products brings with it the hope of
        removing the manufacturing and supply bottlenecks that prevent patients from being able to
        access treatment.
      </p>
      <p className="chapter-paragraph">
        In a <Hyperlink hyperlinkData={hyperlinkData[0]} /> presented by Dr. Fred Locke, Chair of
        the Department of Blood and Marrow Transplant and Cellular Immunotherapy and Program
        Co-Leader, Immuno-Oncology at Moffitt Cancer Center in Tampa, Florida, says that “Allogeneic
        CAR T cell therapy offers the opportunity to address and overcome some of the logistical and
        manufacturing challenges we are seeing in daily practice.”
      </p>
    </section>
  );
}

export default Chapter4;
